import { ArrowLeft, Info } from "lucide-react";
import { useState } from "react";
import MatchCard from "@/components/MatchCard";
import InfoModal from "@/components/InfoModal";

function ProbBox({ label, value, testId }) {
  return (
    <div data-testid={testId} className="border-2 border-[#E3BC55] rounded-2xl bg-black py-4 px-3 text-center">
      <p className="text-[#E3BC55] font-semibold text-sm uppercase tracking-wider">{label}</p>
      <p className="text-white font-heading font-bold text-2xl sm:text-3xl mt-1 font-mono-data">{value}%</p>
    </div>
  );
}

export default function RiepilogoPage({ analysis, goToMovimenti, goToCalcolo }) {
  const [infoOpen, setInfoOpen] = useState(false);
  if (!analysis) {
    return (
      <div className="text-center py-20 fade-up">
        <p className="text-slate-500 mb-4">Nessuna analisi disponibile. Completa prima la Fase Calcolo.</p>
        <button onClick={goToCalcolo} className="text-[#E3BC55] font-heading uppercase text-sm tracking-widest hover:text-[#FFD700]">
          <ArrowLeft className="w-4 h-4 inline mr-1" /> Vai alla Fase Calcolo
        </button>
      </div>
    );
  }

  const { match, riepilogo } = analysis;
  const ou = riepilogo.over_under;

  return (
    <div className="fade-up max-w-xl mx-auto space-y-8">
      <h1 className="font-heading font-bold text-2xl sm:text-3xl text-[#E3BC55] uppercase tracking-[0.18em] text-center">
        Riepilogo Analisi
      </h1>

      <MatchCard match={match} />

      <div className="border-t border-slate-700/60" />

      <div className="flex items-center justify-center gap-3">
        <h2 className="font-heading font-bold text-xl sm:text-3xl text-[#E3BC55] uppercase tracking-[0.06em] sm:tracking-[0.18em] whitespace-nowrap">
          Probabilità Reale
        </h2>
        <button
          data-testid="riepilogo-info-button"
          onClick={() => setInfoOpen(true)}
          className="w-8 h-8 rounded-full bg-[#701A4F] hover:bg-[#8B2364] flex items-center justify-center shrink-0 transition-colors"
          title="Cosa significa Probabilità Reale?"
        >
          <Info className="w-4 h-4 text-white" />
        </button>
      </div>

      {infoOpen && <InfoModal onClose={() => setInfoOpen(false)} />}

      <div data-testid="riepilogo-1x2-card" className="grid grid-cols-3 gap-4">
        <ProbBox label="1" value={riepilogo.blended_1x2["1"]} testId="riepilogo-prob-1" />
        <ProbBox label="X" value={riepilogo.blended_1x2["X"]} testId="riepilogo-prob-x" />
        <ProbBox label="2" value={riepilogo.blended_1x2["2"]} testId="riepilogo-prob-2" />
      </div>

      <div data-testid="riepilogo-overunder-card" className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <ProbBox label="Over 1.5" value={ou.over_15} testId="riepilogo-prob-over15" />
          <ProbBox label="Under 1.5" value={ou.under_15} testId="riepilogo-prob-under15" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <ProbBox label="Over 2.5" value={ou.over_25} testId="riepilogo-prob-over25" />
          <ProbBox label="Under 2.5" value={ou.under_25} testId="riepilogo-prob-under25" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <ProbBox label="Over 3.5" value={ou.over_35} testId="riepilogo-prob-over35" />
          <ProbBox label="Under 3.5" value={ou.under_35} testId="riepilogo-prob-under35" />
        </div>
      </div>

      <button
        data-testid="riepilogo-goto-movimenti-button"
        onClick={goToMovimenti}
        className="w-full py-4 rounded-xl bg-[#E3BC55] text-black font-heading font-bold text-xl uppercase tracking-[0.15em] hover:bg-[#FFD700] transition-colors"
      >
        Risultato Finale
      </button>

      <button onClick={goToCalcolo} className="w-full text-slate-500 font-heading uppercase text-xs tracking-widest hover:text-[#E3BC55] flex items-center justify-center gap-1.5">
        <ArrowLeft className="w-4 h-4" /> Modifica dati
      </button>
    </div>
  );
}
